export default __webpack_public_path__ + "static/media/Innofit_Guide.1f443705.png";